//____________APP Actions____________
export const APP_SET_THEME = 'APP_SET_THEME';

//_______Authentication Actions_______
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';




//____________Entities Actions_________
export const ENTITIES_START = 'ENTITIES_START';
export const ENTITIES_SUCCESS = 'ENTITIES_SUCCESS';
export const ENTITIES_FAIL = 'ENTITIES_FAIL';
export const ENTITIES_GET_ALL = 'ENTITIES_GET_ALL';
export const ENTITIES_SET_PAGE = 'ENTITIES_SET_PAGE';
export const ENTITIES_SET_PAGESIZE = 'ENTITIES_SET_PAGESIZE';
export const ENTITIES_SET_FILTERSQUERY = 'ENTITIES_SET_FILTERSQUERY';
export const ENTITIES_UPDATE_FILTERING = 'ENTITIES_UPDATE_FILTERING';
export const ENTITIES_SET_SORTQUERY = 'ENTITIES_SET_SORTQUERY';
export const ENTITIES_SET_REVERSESORT = 'ENTITIES_SET_REVERSESORT';
export const ENTITIES_UPDATE_SHOWFILTERS = 'ENTITIES_UPDATE_SHOWFILTERS';
export const ENTITY_SELECT_ALL_ROWS = 'ENTITY_SELECT_ALL_ROWS';
export const ENTITY_SELECT_ROW = 'ENTITY_SELECT_ROW';
export const ENTITY_SETHIERARCHIEANDNIVEAUX = 'ENTITY_SETHIERARCHIEANDNIVEAUX';

//____________Campaigns Actions_________
export const CAMPAIGNS_START = 'CAMPAIGNS_START';
export const CAMPAIGNS_SUCCESS = 'CAMPAIGNS_SUCCESS';
export const CAMPAIGNS_FAIL = 'CAMPAIGNS_FAIL';
export const CAMPAIGNS_GET_ALL = 'CAMPAIGNS_GET_ALL';
export const CAMPAIGNS_SET_PAGE = 'CAMPAIGNS_SET_PAGE';
export const CAMPAIGNS_SET_PAGESIZE = 'CAMPAIGNS_SET_PAGESIZE';
export const CAMPAIGNS_SET_FILTERSQUERY = 'CAMPAIGNS_SET_FILTERSQUERY';
export const CAMPAIGNS_UPDATE_FILTERING = 'CAMPAIGNS_UPDATE_FILTERING';
export const CAMPAIGNS_SET_SORTQUERY = 'CAMPAIGNS_SET_SORTQUERY';
export const CAMPAIGNS_SET_REVERSESORT = 'CAMPAIGNS_SET_REVERSESORT';
export const CAMPAIGNS_UPDATE_SHOWFILTERS = 'CAMPAIGNS_UPDATE_SHOWFILTERS';

//____________Users Actions_______________
export const USERS_START = 'USERS_START';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const USERS_FAIL = 'USERS_FAIL';
export const USERS_GET_ALL = 'USERS_GET_ALL';
export const USERS_SET_PAGE = 'USERS_SET_PAGE';
export const USERS_SET_PAGESIZE = 'USERS_SET_PAGESIZE';
export const USERS_SET_FILTERSQUERY = 'USERS_SET_FILTERSQUERY';
export const USERS_UPDATE_FILTERING = 'USERS_UPDATE_FILTERING';
export const USERS_SET_SORTQUERY = 'USERS_SET_SORTQUERY';
export const USERS_SET_REVERSESORT = 'USERS_SET_REVERSESORT';
export const USERS_UPDATE_SHOWFILTERS = 'USERS_UPDATE_SHOW_FILTERS';
export const USERS_SET_SELECTEDALLROWS = 'USERS_SET_SELECTEDALLROWS';
export const USERS_SELECT_USER = 'USERS_SELECT_USER';
export const USERS_UNSELECT_USER = 'USERS_UNSELECT_USER';
export const USERS_EMPTY_SELECTEDUSERS = 'USERS_EMPTY_SELECTEDUSERS';
export const USER_SET_DATA = 'USER_SET_DATA';






